// extracted by mini-css-extract-plugin
module.exports = {"root":"_3zXs9X8dj0AYNkhL3N94gK","contentArea":"_1wcaAprg71zy4-lIYvYsy3"};